<script lang="ts" setup>
  import { Loader2Icon } from 'lucide-vue-next';
  import { Toaster as Sonner } from 'vue-sonner';
  import type { ToasterProps } from 'vue-sonner';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<ToasterProps>();
</script>

<template>
  <Sonner
    :class="
      cn(
        'toaster group [&_[data-icon]]:rounded-sm [&_[data-icon]]:text-base [&_[data-icon]]:flex [&_[data-icon]]:justify-center!',
        props.class,
      )
    "
    :style="{
      '--normal-bg': 'var(--popover)',
      '--normal-text': 'var(--popover-foreground)',
      '--normal-border': 'var(--border)',
      '--border-radius': 'var(--radius)',
    }"
    v-bind="props"
    :toast-options="{
      classes: {
        toast:
          'group-[.toaster]:border-border group-[.toaster]:shadow-xs rounded-2xl ' +
          'group-[.toaster]:rounded group-[.toaster]:py-3',
        success:
          'group toast group-[.toaster]:[&_[data-icon]]:text-success group-[.toaster]:[&_svg]:fill-success',
        warning:
          'group-[.toaster]:[&_[data-icon]]:text-warning group-[.toaster]:[&_svg]:fill-warning',
        error:
          'group-[.toaster]:[&_[data-icon]]:text-destructive group-[.toaster]:[&_svg]:fill-destructive',
      },
    }"
  >
    <template #success-icon>
      <i class="far fa-check-circle" />
    </template>
    <template #info-icon>
      <i class="far fa-circle-info" />
    </template>
    <template #warning-icon>
      <i class="far fa-triangle-exclamation" />
    </template>
    <template #error-icon>
      <i class="far fa-hexagon-exclamation"></i>
    </template>
    <template #loading-icon>
      <div>
        <Loader2Icon class="size-4 animate-spin" />
      </div>
    </template>
    <template #close-icon>
      <i class="fa far fa-close text-2xs text-foreground" />
    </template>
  </Sonner>
</template>
